export enum CommunicationType {
  WELCOME_TEMPLATE = 1,
  SEND_BROCHURE = 2,
  SCHEDULE_SITEVISIT = 3,
  SITEVISIT_REMINDER = 4,
  CALL_NOT_ANSWERED = 5,
  CALL_ANSWERED = 6,
  SEND_QUOTATION = 7,
  PAYMENT_RECEIPT = 8,
  PAYMENT_INVOICE = 9,
  CANCEL_UNIT_APPROVED = 10,
  CANCEL_UNIT_REJECTED = 11,
  DOCUMENT_APPROVED = 12,
  DOCUMENT_REJECTED = 13,
  PAYMENT_APPROVED = 14,
  PAYMENT_REJECTED = 15,
  INVITE_CUSTOMER = 16,
  UNIT_CONFIRMATION = 17,
  PAYMENT_REMINDER = 18,
  DEMAND_LETTER = 19,
  APPLICANT_FORM = 20,
  MILESTONE_UPDATE = 21
}

type communicationType = {
  [key in CommunicationType | number]: string;
};

export const COMMUNICATION_TYPE_MAP: communicationType = {
  [CommunicationType.WELCOME_TEMPLATE]: 'Welcome',
  [CommunicationType.SEND_BROCHURE]: 'Brochure',
  [CommunicationType.SCHEDULE_SITEVISIT]: 'Sitevisit schedule',
  [CommunicationType.SITEVISIT_REMINDER]: 'Sitevisit reminder',
  [CommunicationType.CALL_NOT_ANSWERED]: 'Call not answered',
  [CommunicationType.CALL_ANSWERED]: 'Call answered',
  [CommunicationType.SEND_QUOTATION]: 'Quotation',
  [CommunicationType.PAYMENT_RECEIPT]: 'Payment Receipt',
  [CommunicationType.PAYMENT_INVOICE]: 'Payment invoice',
  [CommunicationType.CANCEL_UNIT_APPROVED]: 'Cancel unit approval',
  [CommunicationType.CANCEL_UNIT_REJECTED]: 'Cancel unit rejection',
  [CommunicationType.DOCUMENT_APPROVED]: 'Document approval',
  [CommunicationType.DOCUMENT_REJECTED]: 'Document rejection',
  [CommunicationType.PAYMENT_APPROVED]: 'Payment Approval',
  [CommunicationType.PAYMENT_REJECTED]: 'Payment Rejection',
  [CommunicationType.INVITE_CUSTOMER]: 'Customer Invitation',
  [CommunicationType.UNIT_CONFIRMATION]: 'Customer unit allotment',
  [CommunicationType.PAYMENT_REMINDER]: 'Payment reminder',
  [CommunicationType.DEMAND_LETTER]: 'Demand letter',
  [CommunicationType.APPLICANT_FORM]: 'Application form',
  [CommunicationType.MILESTONE_UPDATE]: 'Milestone updates'
};
